<template>
  <div class="wrapper" id="app">
    <CardForm
      :form-data="formData"
      @input-price="updatePrice"
      @input-card-number="updateCardNumber"
      @input-card-name="updateCardName"
      @input-card-month="updateCardMonth"
      @input-card-year="updateCardYear"
      @input-card-cvv="updateCardCvv"
    />
    <!-- backgroundImage="https://images.unsplash.com/photo-1572336183013-960c3e1a0b54?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80" -->
  </div>
</template>

<script>
import CardForm from '@/components/CardForm'
export default {
  name: 'app',
  components: {
    CardForm
  },
  data () {
    return {
      formData: {
        price: '',
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      }
    }
  },
  methods: {
    updatePrice (val) {
      this.formData.price = val
    },
    updateCardNumber (val) {
      this.formData.cardNumber = val
    },
    updateCardName (val) {
      this.formData.cardName = val
    },
    updateCardMonth (val) {
      this.formData.cardMonth = val
    },
    updateCardYear (val) {
      this.formData.cardYear = val
    },
    updateCardCvv (val) {
      this.formData.cardCvv = val
    }
  },
  mounted () {
    this.$i18n.locale = navigator.language
  }
}
</script>

<style lang="scss">
@import '../src/assets/style.scss';
</style>
